import Vue from 'vue'
import axios from 'axios'

const option = Vue.observable({ option: {} })
Object.defineProperty(Vue.prototype, '$option', {
  get() {
    return option.option
  },
  set(value) {
    option.option = value
  }
})

Vue.prototype.$initOptions = function () {
  // get data from local storage
  const options = localStorage.getItem('options')
  if (options) {
    Vue.set(Vue.prototype, '$option', JSON.parse(options))
    // init company
    if (Vue.prototype.$option !== null) {
      var printAT =
        Vue.prototype.print_type == 1 || Vue.prototype.print_type == 3
          ? '.sup_data {display:none} .table thead th {padding: 0.2rem;}.table thead th{font-size: 11px;font-weight: 700;padding: 0.2rem;}.table td, .table th {padding: 0.2rem;vertical-align: top;border-top: 1px solid #000;border-left: 1px solid #000;font-size: 11px;font-weight: 600;}.table-hover {margin: 10px;width: calc(100% - 20px);}'
          : ''

      var invoiceFrame = document.getElementById('inviceIframe')
      invoiceFrame.contentDocument.head.innerHTML =
        '<meta charset="utf-8" /><style>' +
        Vue.prototype.$print +
        Vue.prototype.$option.invoice_css +
        '</style>'
      var reportFrame = document.getElementById('printIframe')
      reportFrame.contentDocument.head.innerHTML =
        '<meta charset="utf-8" /><style>' +
        Vue.prototype.$print +
        printAT +
        Vue.prototype.$option.invoice_css +
        '</style>'
      reportFrame.contentDocument.body.classList.add('reportStyle')
    }
    if (Vue.prototype.$option.image) {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      var base_image = new Image()
      base_image.crossOrigin = 'anonymous'

      base_image.src = Vue.prototype.$linkGenerator(
        '/companiesUploads/' +
          localStorage.getItem('subdomain') +
          '/logos/' +
          Vue.prototype.$option.image,
        true
      )
      base_image.onload = function () {
        canvas.width = base_image.width
        canvas.height = base_image.height
        ctx.drawImage(base_image, 0, 0)
        localStorage.setItem('logo', canvas.toDataURL('image/png'))
        canvas.remove()
      }
    } else {
      invoiceFrame.contentDocument.body.innerHTML =
        "<p class='barcode'> *123456789* </p><p class='barcode'> *{{item.code}}* </p>"
    }

    document.getElementById('stylesheetClassic').disabled = true

    document.getElementById('stylesheetTheme1').disabled = true
    document.getElementById('stylesheetTheme2').disabled = true
    document.getElementById('stylesheetTheme3').disabled = true
    document.getElementById('stylesheetTheme4').disabled = true
    document.getElementById('stylesheetTheme5').disabled = true
    document.getElementById('stylesheetTheme6').disabled = true

    if (Vue.prototype.$option.theme_type == 0) {
      document.getElementById('stylesheetClassic').disabled = false
    } else {
      document.getElementById('stylesheetTheme' + Vue.prototype.$option.theme_type).disabled = false
    }
  }
}

Vue.prototype.$getOptions = function () {
  // get data from server
  axios.get(Vue.prototype.$linkGenerator('/options')).then((response) => {
    // set data to local storage
    localStorage.setItem('options', JSON.stringify(response.data.data))
    // set data to vue instance
    Vue.set(Vue.prototype, '$option', response.data.data)
    // init company
    Vue.prototype.$initOptions()
  })
}
